import { FlexBox } from '@dixa/lib-shared-habla';

import { appActions } from 'app/app.actions';
import { MessengerTranslatedLanguage } from 'components/settings/components/sections/dixaMessenger/views/settings/components/generalSettings/languageSettings/languages';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { messengerSettingsActions as actions } from '../../../../messengerSettings.actions';
import { selectKnowledgeState } from '../../../../messengerSettings.selectors';
import {
  ElevioMessengerDisplayType,
  Translatable,
} from '../../../../messengerSettings.types';

import { ElevioIntegration, MessengerConnectElevioModal } from './components';

type Props = {
  /** The messenger id. */
  messengerId: string;
};

/**
 * Knowledge settings component used to configure Elevio integration with the
 * messenger
 */
export function Knowledge({}: Props): JSX.Element {
  const knowledgeState = useAppSelector(selectKnowledgeState);
  const dispatch = useAppDispatch();

  const handleEditElevioAccountId = () => {
    dispatch(
      appActions.showModal({
        modal: { type: 'settings:messengerConnectElevio' },
      }),
    );
  };

  const handleToggleElevioIntegration = () => {
    dispatch(actions.toggleElevioIntegration());
  };

  const handleUpdateDisplayType = (displayType: ElevioMessengerDisplayType) => {
    dispatch(actions.updateDisplayType(displayType));
  };

  const handleLanguageChange = (language: MessengerTranslatedLanguage) => {
    dispatch(actions.changeSelectedLanguage(language));
  };

  const handleTranslatedStringChange = (
    translatable: Translatable,
    language: MessengerTranslatedLanguage,
    value: string,
  ) => {
    dispatch(actions.updateTranslatedString({ translatable, language, value }));
  };

  return (
    <FlexBox flexDirection="column" gap="400">
      <ElevioIntegration
        state={knowledgeState.elevioIntegration}
        selectedLanguage={knowledgeState.selectedLanguage}
        onEditElevioAccountId={handleEditElevioAccountId}
        onToggleElevioIntegration={handleToggleElevioIntegration}
        onUpdateDisplayType={handleUpdateDisplayType}
        onLanguageChange={handleLanguageChange}
        onTranslatedStringChange={handleTranslatedStringChange}
      />
      <MessengerConnectElevioModal />
    </FlexBox>
  );
}
